// extracted by mini-css-extract-plugin
export default {"side-menu-footer":"SideMenuFooter_side-menu-footer__RiTAa"};